/**
 * Чекбокс выбора партии и группы в трёх состояниях и контекст «только
 * смотреть». Вынесено из `components/PlansTable.tsx` (нарезка 14.10.26).
 */

import { createContext, useContext, useEffect, useRef } from "react";
import type { PlanGroup } from "@/lib/plans";
import { PICK } from "./style";

export type PickState = "all" | "some" | "none";

/** Сколько партий группы отмечено: чекбокс группы стоит в трёх состояниях. */
export function pickState(group: PlanGroup, picked: ReadonlySet<number>): PickState {
  const n = group.plans.reduce((sum, plan) => sum + (picked.has(plan.id) ? 1 : 0), 0);
  return n === 0 ? "none" : n === group.plans.length ? "all" : "some";
}

/**
 * Чекбокс выбора. Клик и клавиши гасятся на `label`: строка партии по клику
 * раскрывает состав, заголовок группы — сворачивает группу, и отметка не должна
 * делать ни того, ни другого. Третье состояние — только свойством узла
 * (`indeterminate`), атрибута у него нет.
 */
/** Таблица только для просмотра — контекстом, а не пропом: галочки стоят в
 * двух видах строк, и проброс флага через оба ради одной пустой клетки лишний. */
export const ТолькоЧтение = createContext(false);

export function PickBox({
  state,
  title,
  onChange,
}: {
  state: PickState;
  title: string;
  onChange: (on: boolean) => void;
}) {
  const ref = useRef<HTMLInputElement>(null);
  const readOnly = useContext(ТолькоЧтение);
  useEffect(() => {
    if (ref.current) ref.current.indeterminate = state === "some";
  }, [state]);
  if (readOnly) return <span className={PICK} />;
  return (
    <label
      title={title}
      className={PICK + " cursor-pointer"}
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <input
        ref={ref}
        type="checkbox"
        checked={state === "all"}
        onChange={(event) => onChange(event.target.checked)}
        className="accent-accent"
      />
    </label>
  );
}
